export default "__VITE_ASSET__ce052dfe__"